// 备注：在setinterval中使用aysnc await语法，部分浏览器会报unexpected token function（建议使用.then()）
import axios from 'axios'
import badNetwork from '../../mp3/badNetwork.mp3'
var config = require('../../js/config.js')
var utils = require('../../js/utils/utility.js')

// 默认请求公共地址、头部信息
var domainUrl = config.address

var domainUrl2 = config.address2

var commomHeaders = config.commomHeaders
var configStorage = utils.storage.localGetItem('configStorage');
var adminToken = utils.storage.localGetItem('adminToken');

// adminpost请求
var adminPost = function (url, data) {
	data = data || '';
	return new Promise(function (resolve, reject) {
		axios({
			method: 'post',
			url: domainUrl + url,
			headers: commomHeaders,
			data: data
		})
		.then(function (res) {
			resolve(res.data)
		})
		.catch(function (error) {
			var url = badNetwork
			var audio = new Audio(url);
			audio.src = url;
			audio.play();
			utils.messageError('网络信号不良，请稍后再试')
			// console.log('error', error)
			utils.hideLoading()
			reject(error)
		})
	})
}

// get请求
var get = function (url, data) {
	data = data || '';
	return new Promise(function (resolve, reject) {
		axios({
			method: 'GET',
			url: domainUrl + url,
			headers:{
				'user':configStorage.deviceId,
				'password':adminToken,
				'companyname':configStorage.company_name,
			},
		})
		.then(function (res) {
			resolve(res.data)
		})
		.catch(function (error) {
			var url = badNetwork
			var audio = new Audio(url);
			audio.src = url;
			audio.play();
			utils.messageError('网络信号不良，请稍后再试')
			// console.log('error', error)
			utils.hideLoading()
			reject(error)
		})
	})
}

// post请求
var post = function (url, data) {
	data = data || '';
	return new Promise(function (resolve, reject) {
		axios({
			method: 'post',
			url: domainUrl + url,
			headers:{
				'user': configStorage.deviceId,
				'password': adminToken,
				'companyname': configStorage.company_name,
			},
			data: data,
		})
		.then(function (res) {
			resolve(res.data)
		})
		.catch(function (error) {
			var url = badNetwork
			var audio = new Audio(url);
			audio.src = url;
			audio.play();
			utils.messageError('网络信号不良，请稍后再试')
			// console.log('error', error)
			utils.hideLoading()
			reject(error)
		})
		
	})
}

// post请求
var postform = function (url, data) {
	data = data || '';
	return new Promise(function (resolve, reject) {
		axios({
			method: 'POST',
			url: domainUrl + url,
			headers:{
				'Content-Type':'application/x-www-form-urlencoded'
			},
			data: data,
		})
		.then(function (res) {
			resolve(res.data)
		})
		.catch(function (error) {
			var url = badNetwork
			var audio = new Audio(url);
			audio.src = url;
			audio.play();
			utils.messageError('网络信号不良，请稍后再试')
			// console.log('error', error)
			utils.hideLoading()
			reject(error)
		})
		
	})
}

// post请求
var postform2 = function (url, data) {
	data = data || '';
	return new Promise(function (resolve, reject) {
		axios({
			method: 'POST',
			url: domainUrl + url,
			header:{
				'user':configStorage.deviceId,
				'password':adminToken,
				'companyname':configStorage.company_name,
				'Content-Type':'application/x-www-form-urlencoded'
			},
			data: data,
		})
		.then(function (res) {
			resolve(res.data)
		})
		.catch(function (error) {
			var url = badNetwork
			var audio = new Audio(url);
			audio.src = url;
			audio.play();
			utils.messageError('网络信号不良，请稍后再试')
			// console.log('error', error)
			utils.hideLoading()
			reject(error)
		})
	})
}



export {
	adminPost,
	post,
	get,
	postform,
	postform2
}



//////////////////
// WEBPACK FOOTER
// ./static/CESite40s/js/request.js
// module id = Raz8
// module chunks = 1